// client/src/components/pmPortal/PmPortalLayout.js
// One layout, two navs. The role comes from the session, not from a prop, so there is
// no arrangement of props that shows an owner a tenant's menu.
import React from 'react';
import { Outlet, NavLink, Link } from 'react-router-dom';
import { usePmPortalAuth } from '../../hooks/usePmPortalAuth';

const OWNER_NAV = [
    { to: '/pm-portal/owner', label: 'Overview', end: true },
    { to: '/pm-portal/owner/statement', label: 'Statement' },
    { to: '/pm-portal/owner/budget', label: 'Budget vs Actual' },
    { to: '/pm-portal/owner/projections', label: 'Projections' },
    { to: '/pm-portal/owner/distributions', label: 'Distributions' },
    { to: '/pm-portal/owner/maintenance', label: 'Maintenance' },
    { to: '/pm-portal/documents', label: 'Documents' },
];

const TENANT_NAV = [
    { to: '/pm-portal/tenant', label: 'Overview', end: true },
    { to: '/pm-portal/tenant/lease', label: 'My Lease' },
    { to: '/pm-portal/tenant/ledger', label: 'Charges & Payments' },
    { to: '/pm-portal/tenant/pay', label: 'Pay Rent' },
    { to: '/pm-portal/tenant/maintenance', label: 'Maintenance' },
    { to: '/pm-portal/tenant/notices', label: 'Notices' },
    { to: '/pm-portal/documents', label: 'Documents' },
];

const PmPortalLayout = () => {
    const { logout, role } = usePmPortalAuth();
    const nav = role === 'owner' ? OWNER_NAV : TENANT_NAV;

    return (
        <div className="min-h-screen bg-slate-100">
            <header className="bg-white shadow-sm">
                <div className="max-w-6xl mx-auto flex justify-between items-center h-16 px-6">
                    <Link to="/pm-portal" className="text-lg font-bold text-slate-800">
                        {role === 'owner' ? 'Owner Portal' : 'Resident Portal'}
                    </Link>
                    <button
                        onClick={logout}
                        className="px-4 py-2 text-sm font-medium text-white bg-slate-800 rounded-md hover:bg-slate-900"
                    >
                        Sign Out
                    </button>
                </div>
                <nav className="max-w-6xl mx-auto px-6 border-t border-slate-200">
                    <ul className="flex flex-wrap gap-1 -mb-px">
                        {nav.map(item => (
                            <li key={item.to}>
                                <NavLink
                                    to={item.to}
                                    end={item.end}
                                    className={({ isActive }) =>
                                        `inline-block px-4 py-3 text-sm font-medium border-b-2 ${
                                            isActive
                                                ? 'border-slate-700 text-indigo-700'
                                                : 'border-transparent text-slate-600 hover:text-slate-900'
                                        }`
                                    }
                                >
                                    {item.label}
                                </NavLink>
                            </li>
                        ))}
                    </ul>
                </nav>
            </header>
            <main className="max-w-6xl mx-auto p-6">
                <Outlet />
            </main>
            <footer className="max-w-6xl mx-auto px-6 pb-8 text-xs text-slate-500">
                Funds held for you are maintained in a special account under 68 IAC 1450.750.
                Figures shown here are drawn from that ledger. Questions about a figure should
                go to the managing broker.
            </footer>
        </div>
    );
};

export default PmPortalLayout;
